import {
  MAX_CONCURRENT_REQUESTS,
  REQUESTS_BETWEEN_SAFE_GUARD,
  SAFE_GUARD_TIMEOUT,
} from '@qality/common-model';

async function limitRateSafeGuard(requestCallCount: number) {
  if (requestCallCount % REQUESTS_BETWEEN_SAFE_GUARD === 0) {
    await new Promise((resolve) => setTimeout(resolve, SAFE_GUARD_TIMEOUT));
  }
}

export async function batchRequests<T>(
  requestFunctions: Array<() => Promise<T>>,
  maxConcurrent = MAX_CONCURRENT_REQUESTS
): Promise<T[]> {
  let results: T[] = [];

  for (let i = 0; i < requestFunctions.length; i += maxConcurrent) {
    const batch = requestFunctions.slice(i, i + maxConcurrent);
    const responses = await Promise.all(batch.map((fn) => fn()));
    results = results.concat(responses);
    await limitRateSafeGuard(i);
  }

  return results;
}
